export const columnChooser = {
  ColumnChooser_Header: _TL_('Modify columns'),
  ColumnChooser_SubHeader: _TL_(''),
  ColumnChooser_AvailableColumnsHeader: _TL_('Available columns'),
  ColumnChooser_SelectedColumnsHeader: _TL_('Selected columns (drag and drop to reorder)'),
  ColumnChooser_SelectedColumnsHeader_TopHalf: _TL_('Selected rows'),
  ColumnChooser_SelectedColumnsHeader_BottomHalf: _TL_('Selected columns'),
  ColumnChooser_SaveColumnDescription: _TL_('Save this set of columns'),
  ColumnChooser_Apply: _TL_('Apply'),
  ColumnChooser_Cancel: _TL_('Cancel'),
  ColumnChooser_Add: _TL_('Add'),
  ColumnChooser_Added: _TL_('Added'),
  ColumnChooser_Remove: _TL_('Remove'),
  ColumnChooser_AddAllInList: _TL_('Add all columns'),
  ColumnChooser_RemoveAllInList: _TL_('Remove all columns'),
  ColumnChooser_RemoveAllSelected: _TL_('Remove all selected columns'),
  ColumnChooser_NoSearchResult: _TL_('No results found'),
  ColumnChooser_Disabled: _TL_('Add'),
  ColumnChooser_Search_Column: _TL_('Search column'),
  ColumnChooser_AddColumn: _TL_('Add Column {{columnName}}'),
  ColumnChooser_RemoveColumn: _TL_('Remove Column {{columnName}}'),
  ColumnChooser_LiftColumn: _TL_('You have lifted the {{columnName}} column in position {{positionFrom}}.'),
  ColumnChooser_MoveColumn: _TL_('You have moved the {{columnName}} column from position {{positionFrom}} to position {{positionTo}}.'),
  ColumnChooser_DropColumn: _TL_('You have dropped the {{columnName}} column. You have moved the {{columnName}} column from position {{positionFrom}} to position {{positionTo}}.'),
};

